import AppButton from '@theme/components/atom/AppButton'
import AppImage from '@theme/components/atom/AppImage'
import AppSelect from '@theme/components/atom/AppSelect'
import ProductConfigurationMixin from '~/mixins/ProductConfigurationMixin'
import QuestionMark from '@theme/components/atom/QuestionMark'

const ICON_MAP = {
  'Vyberte si, jakou vložku ("FABku") budou mít Vchodové dveře.': require(`@icon/vlozka_fab.svg?raw`),
  vyber_profilu_dveri_express: require(`@icon/profil.svg?raw`),
  orientace_dvoukridle_balkony_fix: require(`@icon/orientace_okna.svg?raw`),
  orientace_dvoukridle_balkony: require(`@icon/orientace_okna.svg?raw`),
  chair: require(`@icon/chair.svg?raw`),
  orientace_okna: require(`@icon/orientace_okna.svg?raw`),
  profil: require(`@icon/profil.svg?raw`),
  proskleni: require(`@icon/proskleni.svg?raw`),
  'montazni prislusenstvi': require(`@icon/montazni-prislusenstvi.svg?raw`),
  zaluzie: require(`@icon/zaluzie.svg?raw`),
  zaloha_na_zakazkove_zbozi: require(`@icon/zaloha_na_zakazkove_zbozi.svg?raw`),
  'dostupnost_zbozi_3-4': require(`@icon/dostupnost_zbozi_3-4.svg?raw`),
  klika_zamek: require(`@icon/klika_zamek.svg?raw`),
  'venkovni pozink parapet': require(`@icon/venkovni-pozink-parapet.svg?raw`),
  'vnitrni plastovy parapet': require(`@icon/vnitrni-plastovy-parapet.svg?raw`),
  'dekor-venkovni-vnitrni-strana': require(`@icon/dekor-venkovni-vnitrni-strana.svg?raw`),
  'vyber_profilu_dveri_+_zamku': require(`@icon/vyber_profilu_dveri_+_zamku.svg?raw`),
  'svetlik nadsvetlik': require(`@icon/svetlik-nadsvetlik.svg?raw`),
  'dostupnost_zbozi_6-8': require(`@icon/dostupnost_zbozi_6-8.svg?raw`),
  'montazni sada dvere': require(`@icon/montazni-sada-dvere.svg?raw`),
  okapnicka: require(`@icon/okapnicka.svg?raw`),
  Montaz_kliky: require(`@icon/Montaz_kliky.svg?raw`),
  'dostupnost_zbozi_1-2': require(`@icon/dostupnost_zbozi_1-2.svg?raw`),
  klika_madlo: require(`@icon/klika_madlo.svg?raw`),
  proskleni_dveri: require(`@icon/proskleni_dveri.svg?raw`),
  orientace_a_otevirani_dveri: require(`@icon/orientace_a_otevirani_dveri.svg?raw`),
  zamek: require(`@icon/zamek.svg?raw`),
  vlozka_fab: require(`@icon/vlozka_fab.svg?raw`),
  spodek_balkonu: require(`@icon/spodek_balkonu.svg?raw`),
  klapka_madelko: require(`@icon/klapka_madelko.svg?raw`),
  trojkridle_4: require(`@icon/trojkridle_4.svg?raw`),
}

export default {
  name: 'ProductConfiguratorGroups',
  components: { AppButton, AppImage, AppSelect, QuestionMark },
  mixins: [ProductConfigurationMixin],
  props: {
    airShaft: { type: Object },
    configuration: { type: Array, default: [] },
    product: { type: Object, required: true },
    airShaftValues: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      opened: null,
      largerImagesTypeCodes: new Set(),
    }
  },
  created() {
    const types = this.product?.productConfigurationTypes || []
    for (const t of types) {
      if (t?.larger_images) this.largerImagesTypeCodes.add(t.product_configuration_type_code)
    }
  },
  methods: {
    isOpen(id) {
      return this.opened === id
    },
    toggleOpen(id) {
      this.opened = this.opened === id ? null : id
      if (this.opened) this.scrollToOpenGroup(id)
    },
    async scrollToOpenGroup(id) {
      await this.$nextTick()
      const ref = this.$refs[`ProductConfiguratorGroup-${id}`]
      if (ref && ref.length > 0) this.$scrollTo(ref[0], { duration: 100, offset: -200 })
    },
    getGroupIcon(iconName) {
      return ICON_MAP[iconName] || require(`@icon/chair.svg?raw`)
    },
    hasGroupLargerImages(groupCode) {
      return this.largerImagesTypeCodes.has(groupCode)
    },
    getGroupPrice(group) {
      const def = group.configurations.find(i => i.default_price)
      const defaultPrice = def ? def.originalWithTax : 0
      const total = group.configurations.reduce((sum, i) => (i.selected ? sum + i.originalWithTax : sum), 0)
      return total === defaultPrice ? 0 : total
    },
    configurationPrice({ default_price, originalWithTax }) {
      return this.$currencyFormat(default_price ? 0 : originalWithTax)
    },
    select(group, configuration) {
      this.$emit('select-configuration', group, configuration)
    },
    handleAirshaftInput(configuration, group, v) {
      let value = v
      if (v && typeof v === 'object') {
        if ('target' in v) value = v.target?.value
        else if ('value' in v) value = v.value
      }

      if (value === undefined || value === '') value = null
      this.onAirShaftValueChange(configuration.product_configuration_id, value, group)
    },
    onAirShaftValueChange(id, value, group) {
      this.$emit('air-shaft-value-change', id, value)

      if (value == null) return

      const g =
        group ||
        this.product?.productConfigurationGroups?.find(gr =>
          gr.configurations?.some(c => c.product_configuration_id === id),
        )
      if (!g) return
      const cfg = g.configurations.find(c => c.product_configuration_id === id)
      if (cfg && !cfg.selected) this.$emit('select-configuration', g, cfg)
    },
    selectAirshaft(group, configuration) {
      this.select(group, configuration)
      this.onAirShaftValueChange(configuration.product_configuration_id, null, group)
    },
    getAirShaftLabel(configuration) {
      return configuration && ['nadsvetlik', 'nadsvetlik_dvere'].includes(configuration?.code)
        ? this.$t('ProductConfigurator.airShaft.heightLabel')
        : this.$t('ProductConfigurator.airShaft.label')
    },
  },
}
